// src/modules/appointments/components/AppointmentFilters.jsx
import { useState } from "react";
import ContactSelect from "./ContactSelect";

export default function AppointmentFilters({ onChange, config }) {
  const [filters, setFilters] = useState({
    from: "",
    to: "",
    status: "",
    resource_id: "",
    subject_contact_id: "",
    location_id: "",
  });

  function handleChange(e) {
    const { name, value } = e.target;
    const next = { ...filters, [name]: value };
    setFilters(next);
    onChange && onChange(next);
  }

  function setFilter(name, value) {
    const next = { ...filters, [name]: value || "" };
    setFilters(next);
    onChange && onChange(next);
  }

  const resources = Array.isArray(config?.resources) ? config.resources : [];
  const locations = Array.isArray(config?.locations) ? config.locations : [];

  return (
    <div className="flex flex-wrap gap-3 items-end mb-4">
      <div>
        <label className="block text-xs font-semibold">Desde</label>
        <input
          type="datetime-local"
          name="from"
          value={filters.from}
          onChange={handleChange}
          className="border rounded px-2 py-1 text-sm"
        />
      </div>
      <div>
        <label className="block text-xs font-semibold">Hasta</label>
        <input
          type="datetime-local"
          name="to"
          value={filters.to}
          onChange={handleChange}
          className="border rounded px-2 py-1 text-sm"
        />
      </div>
      <div>
        <label className="block text-xs font-semibold">Estado</label>
        <select
          name="status"
          value={filters.status}
          onChange={handleChange}
          className="border rounded px-2 py-1 text-sm"
        >
          <option value="">Todos</option>
          <option value="pending_approval">Pendiente</option>
          <option value="confirmed">Confirmada</option>
          <option value="canceled">Cancelada</option>
        </select>
      </div>
      <div>
        <label className="block text-xs font-semibold">Recurso</label>
        <select
          name="resource_id"
          value={filters.resource_id}
          onChange={handleChange}
          className="border rounded px-2 py-1 text-sm min-w-56"
        >
          <option value="">Todos</option>
          {resources.map((r) => (
            <option key={r.id} value={r.id}>
              {r.name}
            </option>
          ))}
        </select>
      </div>
      <div className="min-w-72">
        <ContactSelect
          label="Paciente / cliente"
          value={filters.subject_contact_id}
          onChange={(value) => setFilter("subject_contact_id", value)}
        />
      </div>
      <div>
        <label className="block text-xs font-semibold">Sede</label>
        <select
          name="location_id"
          value={filters.location_id}
          onChange={handleChange}
          className="border rounded px-2 py-1 text-sm min-w-48"
        >
          <option value="">Todas</option>
          {locations.map((l) => (
            <option key={l.id} value={l.id}>
              {l.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
